import { render, staticRenderFns } from "./jigouDetail.vue?vue&type=template&id=172c4514&scoped=true"
import script from "./jigouDetail.vue?vue&type=script&lang=js"
export * from "./jigouDetail.vue?vue&type=script&lang=js"
import style0 from "./jigouDetail.vue?vue&type=style&index=0&id=172c4514&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172c4514",
  null
  
)

export default component.exports